export default {
    debug: process.env.NODE_ENV !== 'production',
    apiUrl: process.env.VUE_APP_API_URL,
    proxyServer: process.env.PROXY_SERVER
};